import html2canvas from "html2canvas";
import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { Image } from "react-bootstrap-icons";

const FloatingExportButton = ({ targetRef }) => {
  const buttonStyle = {
    width: "50px",
    height: "50px",
    backgroundColor: "#f4a736",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 10px 25px -5px rgba(44, 179, 240, 0.6)",
    transition: "all 0.3s",
    border: "none",
    zIndex: 100,
  };

  const handleDownloadImage = async () => {
    if (!targetRef?.current) return;
    try {
      const canvas = await html2canvas(targetRef.current, {
        useCORS: true,
        logging: true,
        scrollY: -window.scrollY,
      });
      const image = canvas.toDataURL("image/png", 1.0);
      const link = document.createElement("a");
      link.download = "eligibility-details.png";
      link.href = image;
      link.click();
    } catch (error) {
      console.error("Error capturing screenshot:", error);
    }
  };

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip className="bg-info rounded" id="export-tooltip">
          Take Screen shot
        </Tooltip>
      }
    >
      <Button
        variant="primary"
        style={buttonStyle}
        onClick={handleDownloadImage}
      >
        <Image size={25} />
      </Button>
    </OverlayTrigger>
  );
};

export default FloatingExportButton;
